import React, { useEffect } from 'react'
import { analytics } from '@helpers/analytics'
import Translations from '@helpers/translations'
import Link from '@components/ui/Link'
import { Button } from '@components/ui/Button'
import styles from './styles.module.scss'
import { getLink } from '@helpers/env'

const CookieBanner = ({ setGDPRConsent }: { setGDPRConsent: () => void }) => {
  useEffect(() => {
    analytics('Cookie banner - viewed', {
      label: 'Cookie banner',
      source: 'Cookie banner'
    })
  }, [])

  const handleClick = () => {
    setGDPRConsent()
  }

  return (
    <div className={`${styles.gdprContent} grid`}>
      <p className={styles.gdprDescription}>
        {Translations.localise('common.cookie-banner.terms')}{' '}
        <Link
          target="_blank"
          rel="noopener noreferrer"
          classes="gdpr-banner__policy-link"
          href={getLink('/pages/privacy')}
          text={Translations.localise('common.cookie-banner.link')}
        />
        .
      </p>
      <Button
        classes={styles.gdprButton}
        variant="white"
        size="small"
        onClick={handleClick}
      >
        {Translations.localise('common.cookie-banner.close-button')}
      </Button>
    </div>
  )
}

export default CookieBanner
